import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseService } from "projects/assist/src/app/_shared/services/base.service";

import { HotToastService } from "@ngneat/hot-toast";
import { Observable } from "rxjs";
import { OrganizationRelation, OrganizationRelationExpanded } from "../models/organizationRelation";

@Injectable({
  providedIn: "root",
})
export class OrganizationRelationService extends BaseService<
  OrganizationRelation,
  OrganizationRelationExpanded
> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string,
    protected override toast: HotToastService
  ) {
    super(http, baseUrl, "OrganizationRelation", toast);
  }

  public isChild(parentId: number, relationTypeId?: number): Observable<boolean> {
    return this.get(`/isChild?parentId=${parentId}&relationTypeId=${relationTypeId}`);
  }

  public getParentRelations() {
    return this.getAll(`/parentRelations`);
  }
}
